module.exports = ".padtop10 {\r\n  padding-top: 10px\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/active-shipments/active-shipments.component.css
// module id = ./src/app/active-shipments/active-shipments.component.css
// module chunks = main